import { render, staticRenderFns } from "./EducationQuestionsDetail.vue?vue&type=template&id=4e36ec52&scoped=true&"
import script from "./EducationQuestionsDetail.vue?vue&type=script&lang=js&"
export * from "./EducationQuestionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./EducationQuestionsDetail.vue?vue&type=style&index=0&id=4e36ec52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36ec52",
  null
  
)

export default component.exports